import { t } from '../../utils/ui-strings';
import type { TryOnErrorCode } from '../../types/tryOn';

interface TryOnErrorStateProps {
  errorCode?: TryOnErrorCode;
  message?: string;
  onRetry: () => void;
  lang?: string;
}

/**
 * Backend svarar med maskinläsbara felkoder; översättningen bor här.
 *
 * Record<TryOnErrorCode, ...> med flit: läggs en ny felkod till i typen
 * slutar det här att kompilera tills koden fått copy. Ett fel utan text
 * skulle annars falla tillbaka på "något gick fel" och tysta bort just den
 * information kunden behöver för att lyckas nästa gång.
 */
const ERROR_KEYS: Record<TryOnErrorCode, Parameters<typeof t>[0]> = {
  NO_PERSON_DETECTED: 'try_on_err_no_person',
  MULTIPLE_PEOPLE_DETECTED: 'try_on_err_multiple_people',
  UNSUPPORTED_PRODUCT: 'try_on_err_unsupported_product',
  IMAGE_TOO_LOW_QUALITY: 'try_on_err_low_quality',
  GENERATION_FAILED: 'try_on_err_generation_failed',
  CONTENT_POLICY_FAILED: 'try_on_err_content_policy',
  FACE_PRESERVE_FAILED: 'try_on_err_face_preserve',
  FEET_NOT_VISIBLE: 'try_on_err_feet_not_visible',
  INPUT_DELETED: 'try_on_err_input_deleted',
};

export function TryOnErrorState({ errorCode, message, onRetry, lang }: TryOnErrorStateProps) {
  return (
    <div className="rounded-2xl bg-red-50 p-5 text-red-800">
      <h3 className="font-semibold">{t('try_on_error_title', lang)}</h3>
      <p className="mt-2 text-sm">
        {message ?? t(ERROR_KEYS[errorCode ?? 'GENERATION_FAILED'], lang)}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-4 rounded-lg border border-red-700 px-4 py-2 text-sm font-medium hover:bg-red-100"
      >
        {t('try_on_retry', lang)}
      </button>
    </div>
  );
}
